<ul class="sub-menu-v2 active">
    <app-sidebar2-checkbox
        *ngIf="statuses.length > 0"
        [statuses]="statuses"
        [settingsFlag]="settingsFlag"
        [defaultRoute]="defaultRoute"></app-sidebar2-checkbox>

    <li [ngClass]="{ active: templateActive }">
        <header (click)="getHeaderLink()" class="sub-menu-v2--header open">
            <label>Templates</label>
        </header>
    </li>
</ul>
